import React from "react";
import { Helmet } from "react-helmet-async";
import GetInTouch from "../components/GetInTouch";
import GetStarted from "../components/GetStarted";
import Header from "../components/Header";
import Footer from "../components/Footer/Footer";
import BarraApp from "../componentsPeopletech/Barraaps";

const Home = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>Sammy - Inicio</title>
        <meta name="description" content="Descripción de tu página de inicio de Sammy. Describe aquí el contenido principal." />
        <meta name="keywords" content="sammy, landing page, inicio" />
        <link rel="canonical" href="https://tudominio.com/sammy/home" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tudominio.com/sammy/home" />
        <meta property="og:title" content="Sammy - Inicio" />
        <meta property="og:description" content="Descripción de tu página de inicio de Sammy." />
        <meta property="og:image" content="https://tudominio.com/ruta-a-tu-imagen.jpg" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://tudominio.com/sammy/home" />
        <meta property="twitter:title" content="Sammy - Inicio" />
        <meta property="twitter:description" content="Descripción de tu página de inicio de Sammy." />
        <meta property="twitter:image" content="https://tudominio.com/ruta-a-tu-imagen.jpg" />
        
        {/* Schema.org JSON-LD para SEO de IA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Sammy",
            "url": "https://tudominio.com/sammy/home",
            "description": "Descripción de tu página de inicio de Sammy. Describe aquí el contenido principal.",
            "logo": "https://tudominio.com/logo-sammy.png"
          })}
        </script>
      </Helmet>
      <BarraApp />
      <Header />
      <GetStarted />
      <Footer />
    </>
  );
};

export default Home;
